import { getBtnListSwitch,getWorkOrderListSwitch } from '@api'
export default {
	state: {
		btnSettings: [{
			//是否显示
			display: true,
			//编号
			fieldKey: null,
			//名称
			name:null,
			//排序
			rank: null
		}],
		workOrderSettings: [{
			//是否显示
			display: true,
			//编号
			fieldKey: null,
			//名称
			name: null,
			//显示名称
			displayName:null,
			//排序
			rank: null
		}]
	},
	mutations: {
		//设置按钮列表
		setBtnSettings(state, btnList) {
			state.btnSettings = btnList
		},
		//设置按钮列表
		setworkOrderSettings(state, workOrderList) {
			state.workOrderSettings = workOrderList
		}
	},
	actions: {
		refreshAllSettings(){
			this.dispatch('refreshBtnSettings')
			this.dispatch('refreshOrderFieldSettings')
		},
		//请求接口获取按钮设置
		async refreshBtnSettings(){
			//访问api获取设置
			let {data} = await getBtnListSwitch()
			this.state.btnSettings = data
		},
		//请求接口获取工单字段设置
		async refreshOrderFieldSettings(){
			//访问api获取设置
			let {data} = await getWorkOrderListSwitch()
			//console.log('getWorkOrderListSwitch',data)
			this.state.workOrderSettings = data
		}
	},
	getters: {
		// 获取按钮设置列表
		getBtnList(state) {
			return state.btnSettings || []
		},
		// 获取工单设置列表
		getWorkOrderSettings(state) {
			return state.workOrderSettings || []
		}
	},
}
